import React from 'react';

/**
 * Flerpie's outline in one tone (currentColor), traced from the neutral sprite
 * (avatars/firefly-neutral.svg): head, body pod, wings and antennae, with no face. Same
 * coordinates as the sprite. The antennae and their tips are thicker than his so they
 * survive at 20px.
 */
const FlerpieSilhouette: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="10 -6 100 100" fill="none" aria-hidden="true" focusable="false" className={className}>
    <ellipse cx="42" cy="56" rx="16" ry="24" transform="rotate(25 42 56)" fill="currentColor" />
    <ellipse cx="78" cy="56" rx="16" ry="24" transform="rotate(-25 78 56)" fill="currentColor" />
    <path
      d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z"
      fill="currentColor"
    />
    <ellipse cx="60" cy="28" rx="22" ry="20" fill="currentColor" />
    <path d="M52.6 13.2 Q48.5 2 40.6 -1.2 L39.4 4.4 Q44.5 6 47.4 14.8 Z" fill="currentColor" />
    <path d="M67.4 13.2 Q71.5 2 79.4 -1.2 L80.6 4.4 Q75.5 6 72.6 14.8 Z" fill="currentColor" />
    <circle cx="39" cy="1.5" r="5" fill="currentColor" />
    <circle cx="81" cy="1.5" r="5" fill="currentColor" />
  </svg>
);

export default FlerpieSilhouette;
